<template>
  <base-modal :box="box_init" :step="step">
    <template slot="description">
      <div>
        {{$t('pbx.worksheet.action.queue.state.init.description')}}
        <router-link :to="{ name: 'pbx.service-package.index' }">
          <span @click='$refs.close.$el.click()'> {{ $t('pbx.breadcrumb.title') }} </span>
        </router-link> -
        <router-link :to="{ name: 'pbx.operator.index' }">
          <span @click='$refs.close.$el.click()'> {{ $t('pbx.breadcrumb.operator.index') }} </span>
        </router-link > -
        <router-link :to="{ name: 'pbx.contact.index' }">
          <span @click='$refs.close.$el.click()'> {{ $t('pbx.breadcrumb.contact.index') }} </span>
        </router-link>
      </div>
    </template>
    <z-form ref="form" @submit.native.prevent="save">
      <form-input-name v-model="form.name" :box_type="box.type" />

      <z-form-group class="row">
        <div class="col-4 text-right">{{ $t('pbx.worksheet.action.queue.input.type.label') }}</div>
        <z-form-input class="col-8">
          <type-select v-model="form.params.type" />
        </z-form-input>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-4 text-right">
          {{ $t('pbx.worksheet.action.queue.input.timeout.label') }}
        </div>
        <z-form-input class="col-8">
          <time-select v-model="form.params.timeout" />
        </z-form-input>
      </z-form-group>

      <contacts-and-groups
        :list_of_groups="list_of_groups"
        :current_contact_groups.sync="form.params.contact_groups"
        :list_of_contact_methods="list_of_contact_methods"
        :current_contact_methods.sync="form.params.contact_methods"
        :current_tab="current_tab"
        @change-step="set_step"
      />
    </z-form>

    <i-button 
      slot="footer-cancel"
      slot-scope="{ close }"
      size="large"
      @click="close()"
      ref='close'
    >
      {{ $t('pbx.worksheet.modal.action.main.button.cancel') }}
    </i-button>
    <i-button
      slot="footer-ok"
      slot-scope="{ is_button_loading }"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('pbx.worksheet.modal.action.main.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import FormInputName from '../../../_base/_fragments/form-input-name';
  import TypeSelect from '@pbx/components/worksheets/action-types/_fragments/select-queue-type';
  import TimeSelect from '@pbx/components/worksheets/action-types/_fragments/select-time';
  import ContactsAndGroups from './contacts-and-groups';
  import { StepMixin } from '../../../_base/step-mixin';

  /**
   * props.box - автоматически прокидывается в form
   * чтобы сохранить состояние шага, используй mixin_save_step из StepMixin
   */

  export default {
    components: { BaseModal, FormInputName, TypeSelect, TimeSelect, ContactsAndGroups },
    mixins: [StepMixin],

    props: {
      current_tab: {
        type: String,
        required: true
      },

      list_of_contact_methods: {
        type: Array,
        default: () => []
      },

      list_of_groups: {
        type: Array,
        default: () => []
      }
    },

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const box = this.mixin_get_box(this.form);
            this.$emit('on-save', box);
          }
        });
      },

      set_step(name) {
        this.mixin_save_step(this.form);
        this.mixin_set_step(name);
      }
    }
  };
</script>
